<script lang="ts" setup>
import { cva, type VariantProps } from 'class-variance-authority'
import { PhCaretRight, PhArrowRight } from '@phosphor-icons/vue'

import { classMerge } from '@toni/brand-ui'

const purchaseOptionButtonVariants = cva('inline-flex justify-center items-center font-button', {
  variants: {
    variant: {
      primary: 'bg-action-primary-background text-action-primary-foreground',
      highlighted: 'bg-action-primaryInverted-background text-action-primaryInverted-foreground'
    },
    size: {
      md: '',
      lg: 'text-button-md border-action-stroke rounded-action-primary h-[2.75rem] p-2'
    }
  },

  compoundVariants: [
    {
      variant: 'highlighted',
      size: 'md',
      class: 'bg-inherit text-action-primary-foreground'
    },
    {
      variant: 'primary',
      size: 'md',
      class: 'bg-inherit text-action-primaryInverted-foreground'
    }
  ],

  defaultVariants: {
    size: 'lg'
  }
})

type PurchaseOptionButtonProps = VariantProps<typeof purchaseOptionButtonVariants>

withDefaults(
  defineProps<{
    variant?: PurchaseOptionButtonProps['variant'],
    size?: PurchaseOptionButtonProps['size'],
  }>(),
  {
    variant: 'primary',
    size: 'lg'
  }
)
</script>

<template>
  <div :class="classMerge(purchaseOptionButtonVariants({ variant, size }), $attrs.class ?? '')">
    <div v-if="size !== 'lg'"
         class="flex items-center">
      <PhCaretRight size="20"
                    class="ml-2" />
    </div>
    <div v-else
         class="flex items-center gap-1">
      <span class="text-button-xs">{{ $t('commerce.viewOffer') }}</span>
      <PhArrowRight size="18" />
    </div>
  </div>
</template>
